export default API => ({
    findByCondition(url, data){
        return API({ url: `/raas/v1/paperManage/findByCondition?${url}`, method:'post', data });
    },
    delete(id){
        return API({ url: `/raas/v1/paperManage/delete?id=${id}`, method:'get' });
    },
    updateStatusById(id, status) {
        return API({ url: `/raas/v1/paperManage/updateStatusById?id=${id}&status=${status}`, method:'get' });
    },
    updateById(data) {
        return API({ url: '/raas/v1/paperManage/updateById', method:'post', data});
    },
    // 创建试卷
    save(data) {
        return API({ url: 'raas/v1/paperManage/save', method:'post', data});
    },
    // 手动组卷--保存试题
    saveBatch(data) {
        return API({ url: '/raas/v1/paperQuestionManage/saveBatch', method:'post', data});
    },
    // 根据试卷id查询试卷（管理）
    findById(id) {
        return API({ url: `/raas/v1/paperManage/findById?id=${id}`, method:'get'});
    },
    // 根据分类查询试题类型和总数
    getfindQuestionCountByCategoryIds(data) {
        return API({ url: `/raas/v1/paperManage/findQuestionCountByCategoryIds`, method: 'post', data});
    },
    // 获取更换试题（智能组卷
    findNotExitListByIds(id, type, name, pageNum, pageSize) {
        return API({ url: `/raas/v1/paperManage/findNotExitListByIds?id=${id}&type=${type}&title=${name}&pageNum=${pageNum}&pageSize=${pageSize}`, method: 'get'});
    },
    // 试卷更换试题
    paperQuestionManageUpdateById(data) {
        return API({ url: '/raas/v1/paperQuestionManage/updateById', method:'post', data});
    },
})
